/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verification_Link_ExpiredInputs */

const en_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The link is no longer valid. Please try again.`)
};

const id_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautan sudah tidak berlaku. Coba lagi.`)
};

const ms_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pautan tidak lagi sah. Sila cuba lagi.`)
};

const ca_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'enllaç ja no és vàlid. Si us plau, torna-ho a intentar.`)
};

const cs_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkaz už není platný. Zkuste to prosím znovu.`)
};

const da_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linket er ikke længere gyldigt. Prøv venligst igen.`)
};

const de_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Link ist nicht mehr gültig. Bitte versuche es erneut.`)
};

const et_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link ei ole enam kehtiv. Palun proovige uuesti.`)
};

const es_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El enlace ya no es válido. Vuelve a intentarlo.`)
};

const fr_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le lien n’est plus valide. Veuillez réessayer.`)
};

const hr_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ova poveznica više nije valjana. Pokušajte ponovno.`)
};

const it_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il link non è più valido. Riprova.`)
};

const lv_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saite vairs nav derīga. Lūdzu, mēģiniet vēlreiz.`)
};

const lt_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuoroda nebegalioja. Bandykite dar kartą.`)
};

const hu_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A link már nem érvényes. Kérjük, próbálja meg újra.`)
};

const nl_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De link is niet langer geldig. Probeer het opnieuw.`)
};

const nb_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lenken har utløpt. Prøv på nytt.`)
};

const pl_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link jest już nieaktualny. Spróbuj ponownie.`)
};

const pt_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O link não é mais válido. Tente novamente.`)
};

const ro_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link-ul nu mai este valid. Te rugăm să încerci din nou.`)
};

const sk_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkaz už nie je platný. Skúste to prosím znova.`)
};

const sl_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Povezava ni več veljavna. Poskusite znova.`)
};

const fi_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linkki ei ole enää voimassa. Yritä uudelleen.`)
};

const sv_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länken är inte längre giltig. Vänligen försök igen.`)
};

const vi_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên kết này không còn hợp lệ. Vui lòng thử lại.`)
};

const tr_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlantı artık geçerli değil. Lütfen tekrar deneyin.`)
};

const el_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ο σύνδεσμος δεν ισχύει πλέον. Δοκιμάστε ξανά.`)
};

const bg_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Линкът вече не е валиден. Моля, опитай отново.`)
};

const ru_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ссылка больше не действительна. Пожалуйста, попробуйте еще раз.`)
};

const sr_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Линк више није важећи. Пробајте поново.`)
};

const uk_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посилання більше не діє. Будь ласка, спробуйте ще раз.`)
};

const ka_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ბმული აღარ არის მოქმედი. გთხოვთ, სცადოთ ხელახლა.`)
};

const hi_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंक अब वैलिड नहीं है। कृपया फिर से कोशिश करें।`)
};

const th_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลิงก์นี้ไม่สามารถใช้งานได้แล้ว ลองใหม่อีกครั้ง`)
};

const ko_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`링크가 더 이상 유효하지 않습니다. 다시 시도해 주세요.`)
};

const zh_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接已失效。请重试。`)
};

const zh_tw_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連結已失效。請再試一次。`)
};

const ja_verification_link_expired = /** @type {(inputs: Verification_Link_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクが無効です。もう一度やり直してください。`)
};

/**
* | output |
* | --- |
* | "The link is no longer valid. Please try again." |
*
* @param {Verification_Link_ExpiredInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const verification_link_expired = /** @type {((inputs?: Verification_Link_ExpiredInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verification_Link_ExpiredInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_verification_link_expired(inputs)
	if (locale === "ms") return ms_verification_link_expired(inputs)
	if (locale === "ca") return ca_verification_link_expired(inputs)
	if (locale === "cs") return cs_verification_link_expired(inputs)
	if (locale === "da") return da_verification_link_expired(inputs)
	if (locale === "de") return de_verification_link_expired(inputs)
	if (locale === "et") return et_verification_link_expired(inputs)
	if (locale === "es") return es_verification_link_expired(inputs)
	if (locale === "fr") return fr_verification_link_expired(inputs)
	if (locale === "hr") return hr_verification_link_expired(inputs)
	if (locale === "it") return it_verification_link_expired(inputs)
	if (locale === "lv") return lv_verification_link_expired(inputs)
	if (locale === "lt") return lt_verification_link_expired(inputs)
	if (locale === "hu") return hu_verification_link_expired(inputs)
	if (locale === "nl") return nl_verification_link_expired(inputs)
	if (locale === "nb") return nb_verification_link_expired(inputs)
	if (locale === "pl") return pl_verification_link_expired(inputs)
	if (locale === "pt") return pt_verification_link_expired(inputs)
	if (locale === "ro") return ro_verification_link_expired(inputs)
	if (locale === "sk") return sk_verification_link_expired(inputs)
	if (locale === "sl") return sl_verification_link_expired(inputs)
	if (locale === "fi") return fi_verification_link_expired(inputs)
	if (locale === "sv") return sv_verification_link_expired(inputs)
	if (locale === "vi") return vi_verification_link_expired(inputs)
	if (locale === "tr") return tr_verification_link_expired(inputs)
	if (locale === "el") return el_verification_link_expired(inputs)
	if (locale === "bg") return bg_verification_link_expired(inputs)
	if (locale === "ru") return ru_verification_link_expired(inputs)
	if (locale === "sr") return sr_verification_link_expired(inputs)
	if (locale === "uk") return uk_verification_link_expired(inputs)
	if (locale === "ka") return ka_verification_link_expired(inputs)
	if (locale === "hi") return hi_verification_link_expired(inputs)
	if (locale === "th") return th_verification_link_expired(inputs)
	if (locale === "ko") return ko_verification_link_expired(inputs)
	if (locale === "zh") return zh_verification_link_expired(inputs)
	if (locale === "zh-tw") return zh_tw_verification_link_expired(inputs)
	if (locale === "ja") return ja_verification_link_expired(inputs)
	return en_verification_link_expired(inputs)
});